/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import MPHFooterPrimary from "src/components/actionPerformers/MPHFooterPrimary/MPHFooterPrimary";
import MPHFooterSecondary from "src/components/actionPerformers/MPHFooterSecondary/MPHFooterSecondary";
import MPHHeaderMain from "src/components/actionPerformers/MPHHeaderMain/MPHHeaderMain";
import "./HomePage.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useStorage } from "src/utils/storage";
import MPHFindHotels from "src/components/actionPerformers/MPHFindHotels/MPHFindHotels";
import MPHLogin from "src/components/actionPerformers/MPHLogin/MPHLogin";
import MPHSignUp from "src/components/actionPerformers/MPHSignUp/MPHSignUp";
// import { useMPHSSO } from "src/utils/ApiService/MPHSSO";
// import { useBlockUIContext } from "ns-react-block-ui";
// import Swal from "sweetalert2";
// import useAuth from "src/context/AuthContext";
import ReactGA from "react-ga";
import { AUTH_TYPES } from "src/config/constants";

// interface AuthType {
//   type: "find-hotels" | "login" | "signup" | "create-password" | "forgot-password";
// }

const HomePage = (authType: any) => {
  // const { setBlockUI } = useBlockUIContext();
  // const { setUserProfile, clearStorage } = useAuth();
  // const [isSwal, setIsSwal] = useState(false);
  const navigate = useNavigate();
  const storage = useStorage();
  const location = useLocation();
  // const { getCustomerLookUpApi } = useMPHSSO();

  // const isSsoNavigation = () => {
  //   if (location.search.includes("backurl")) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // const ssoConfirmation = (user: any) => {
  //   if (Swal.isVisible() || isSwal) {
  //     return;
  //   }
  //   Swal.fire({
  //     title: "Confirmation",
  //     text: `You are logged in as ${user.profileName}, Would you like to continue or login in with new profile`,
  //     icon: "info",
  //     cancelButtonText: "New Login",
  //     confirmButtonText: "Continue",
  //     showCancelButton: true,
  //     customClass: {
  //       confirmButton: "secondary-button",
  //       cancelButton: "secondary-button",
  //     },
  //   }).then(
  //     async (res) => {
  //       if (res.isConfirmed) {
  //         setBlockUI({ blocking: true });
  //         await getCustomerLookUpApi(user);
  //         setBlockUI({ blocking: false });
  //         navigate(`/${AUTH_TYPES.FIND_HOTELS}`);
  //       }
  //       if (res.isDismissed) {
  //         clearStorage();
  //         setUserProfile(null);
  //       }
  //     },
  //     () => {}
  //   );
  // };

  const checkIsLogin = async () => {
    const profile: any = await storage.get("user_profile");
    const promotionPage = (await storage.get("promotion")) || "";
    const user = profile && JSON.parse(profile || {});
    const isModifyReservationPath =
      location.pathname === "/login_reservation_modify";

    if (user && user.isProfileExist && authType && authType.type) {
      if (promotionPage === "true") {
        // No redirect needed for promotion page
      } else if (!isModifyReservationPath) {
        navigate("/find-hotels");
      }
    } else if (authType && authType.type === "find-hotels") {
      navigate("/login");
    } else if (
      (!user || !user.isProfileExist) &&
      (!authType || !authType.type)
    ) {
      navigate("/login");
    }
  };

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
    checkIsLogin();
    // setIsSwal(true);
  }, [authType, location.pathname]);

  const renderHelmet = () => {
    switch (authType?.type) {
      case AUTH_TYPES.SIGNUP:
        return (
          <Helmet>
            <title>Join Stay Rewarded - My Place Hotels Signup</title>
            <meta name="description" content="Sign up for Stay Rewarded and enjoy exclusive member benefits, earn points on stays, and get the best rates with My Place Hotels." />
          </Helmet>
        );
      case AUTH_TYPES.LOGIN:
      case AUTH_TYPES.CREATE_PASSWORD:
      case AUTH_TYPES.FORGOT_PASSWORD:
        return (
          <Helmet>
            <title>Stay Rewarded Login - My Place Hotels</title>
            <meta name="description" content="Log in to your Stay Rewarded account. Access member benefits, view stay history, redeem points, and manage your profile easily." />
          </Helmet>
        );
      default:
        return null;
    }
  };

  const renderContent = () => {
    switch (authType?.type) {
      case AUTH_TYPES.FIND_HOTELS:
        return <MPHFindHotels />;
      case AUTH_TYPES.LOGIN:
      case AUTH_TYPES.CREATE_PASSWORD:
      case AUTH_TYPES.FORGOT_PASSWORD:
        return <MPHLogin screenType={authType.type} />;
      case AUTH_TYPES.SIGNUP:
        return <MPHSignUp />;
      default:
        return null;
    }
  };

  return (
    <>
      {renderHelmet()}
      <MPHHeaderMain active="" />
      <div className="margin-top">
        <section className="home-background">
          {renderContent()}
        </section>
        <MPHFooterPrimary />
        <MPHFooterSecondary />
      </div>
    </>
  );
};

export default HomePage;
